import React, { useState, useEffect } from 'react'
import Title from '../../../components/common/Title/Title'
import Breadcrumb from '../../../components/common/Breadcrumb/Breadcrumb'
import { filterIsUsed, initFilterInput, renderColumns } from './constants';
import CustomTable from "../../../components/common/Table/CustomTable";
import httpclient from '../../../components/httpclient';
import SwalToast from '../../../components/helpers/SwalToast';
import { AxiosCustomGet, AxiosCustomPost, AxiosCustomPut } from '../../../components/axios/AxiosCustom';
import Cookies from "js-cookie";
import Config from "../../../components/axios/Config";
import Swal from "sweetalert2";
import TextInput from '../../../components/common/TextInput/TextInput';
import { Button, Modal } from "antd";
import CustomDatePicker from '../../../components/common/DatePicker/CustomDatePicker';
import moment from 'moment';
import MultipleSelect from '../../../components/common/MultipleSelect/MultipleSelect';
import ModalSelectGadaiBySbg from './components/ModalSelectGadaiBySbg';
import ModalVoucherSetting from './components/ModalVoucherSetting';
import { convertListVoucher } from './helpers/convertListVoucher';
import { convertListGadai } from './helpers/convertListGadai';

export default function Voucher() {

    const [records, setRecords] = useState([]);
    const [totalRecords, setTotalRecords] = useState();
    const [id, setId] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filterInput, setFilterInput] = useState(initFilterInput);
    const [tablePagination, setTablePagination] = useState({});
    const [transactionDateValue, setTransactionDateValue] = useState([]);
    const [modalSelectGadai, setModalSelectGadai] = useState(false);
    const [modalSettingVoucher, setModalSettingVoucher] = useState(false);
    const [selected, setSelected] = useState({});
    const [dataVoucher, setDataVoucher] = useState({});
    const [errors, setErrors] = useState()
    const [isEditOrCreate, setIsEditOrCreate] = useState('create')
    const [filterUsedValue, setFilterUsedValue] = useState({
        label: "Semua",
        value: "",
    });

    useEffect(() => {
        getData();
    }, [filterInput]);

    const getData = () => {
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/voucher`;
        let params = {
            search: filterInput.search,
            page: filterInput.page,
            size: filterInput.pageSize,
            status: filterInput.isUsed,
            date_used_start: filterInput.usedDateStart ? moment(filterInput.usedDateStart).format('YYYY-MM-DD') : null,
            date_used_end: filterInput.usedDateEnd ? moment(filterInput.usedDateEnd).format('YYYY-MM-DD') : null,
        };
        // console.log(params)
        AxiosCustomGet(
            url,
            Config(
                {
                    Authorization: `Bearer ${Cookies.get("access_token")}`,
                },
                params
            ),
            (response) => {
                let data = response.data.data;
                let dataConverted = convertListVoucher(response.data.data.items)
                // console.log('voucher', data)
                setRecords(dataConverted);
                setTotalRecords(data.total_item);
                setLoading(false);
                setTablePagination({
                    current: response.data.data?.page,
                    pageSize: response.data.data?.per_page,
                    total: response.data.data?.total_item,
                });
            },
            (error) => {
                console.log(error);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const handleTableChange = (pagination) => {
        setFilterInput((prev) => ({
            ...prev,
            page: pagination.current,
            pageSize: parseInt(pagination.pageSize),
        }));
    };

    const handleDelete = (record) => {
        setSubmitting(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/delete-voucher/${record.voucherId}`;
        Swal.fire({
            title: "Hapus Data",
            text: "Apakah anda yakin ingin menghapus voucher " + record.name,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Hapus",
            cancelButtonText: "Batal",
        }).then((result) => {
            if (result.isConfirmed) {
                httpclient
                    .DELETE(url)
                    .then((response) => {
                        SwalToast.fire({
                            icon: "success",
                            title: response.data.message,
                        });
                        getData();
                        setSubmitting(false);
                    })
                    .catch((error) => {
                        console.log(error);
                        if (error.response) {
                            SwalToast.fire({
                                icon: "error",
                                title: error.response.data.error.message,
                            });
                        } else {
                            SwalToast.fire({
                                icon: "error",
                                title: "Whoops, something went wrong",
                            });
                            setSubmitting(false);
                        }
                    });
            }
        });
    };

    const validate = () => {
        const newErrors = {};

        if (!dataVoucher.name) {
            newErrors.name = "Nama voucher harus diisi";
        }
        if (!dataVoucher.amount) {
            newErrors.amount = "Jumlah potongan harus diisi";
        }

        return newErrors;
    };

    const onCreateVoucher = () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            let data = {
                gadai_id: dataVoucher.gadaiId,
                voucher_name: dataVoucher.name,
                voucher_amount: parseInt(dataVoucher.amount),
                gadai_installment_id: dataVoucher.installmentId,
                id: dataVoucher.voucherId
            }
            // console.log(data); return
            setLoading(true);
            if (!dataVoucher.voucherId) {
                let url = `${process.env.REACT_APP_BASE_API_URL}gadai/create-voucher`;
                AxiosCustomPost(url, data, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
                    (response) => {
                        setModalSettingVoucher(false)
                        getData()
                        setDataVoucher({ name: '', amount: '' })
                        setSelected({})
                        setFilterInput(initFilterInput)
                    },
                    (error) => {
                        console.log(error.response.data)
                        setLoading(false);
                        if (error.response) {
                            SwalToast.fire({
                                icon: "error",
                                title: error.response.data.error.message,
                            });
                        } else {
                            SwalToast.fire({
                                icon: "error",
                                title: "Whoops, something went wrong",
                            });
                        }
                    }
                );
            } else {
                let url = `${process.env.REACT_APP_BASE_API_URL}gadai/update-voucher`;
                AxiosCustomPut(url, data, Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
                    (response) => {
                        setModalSettingVoucher(false)
                        getData()
                        setDataVoucher({ name: '', amount: '' })
                        setSelected({})
                        setFilterInput(initFilterInput)
                    },
                    (error) => {
                        console.log(error.response.data)
                        setLoading(false);
                        if (error.response) {
                            SwalToast.fire({
                                icon: "error",
                                title: error.response.data.error.message,
                            });
                        } else {
                            SwalToast.fire({
                                icon: "error",
                                title: "Whoops, something went wrong",
                            });
                        }
                    }
                );
            }
        }
    }
    const handleEdit = (record) => {
        let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${record.gadaiId}`
        AxiosCustomGet(
            url,
            Config({ Authorization: `Bearer ${Cookies.get("access_token")}` }),
            (response) => {
                let data = convertListGadai(response.data.data);
                setDataVoucher(record)
                setSelected({ ...data, installmentId: record.installmentId })
            },
            (error) => {
                console.log(error);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
        setModalSettingVoucher(true);
        setId(record.id);
        setIsEditOrCreate('edit')
    };

    const handleDateChange = (event) => {
        const startDate = moment(event?.[0]?._d).startOf("day");
        const endDate = moment(event?.[1]?._d).startOf("day");

        setTransactionDateValue(event ? [startDate, endDate] : null);
        setFilterInput((prev) => ({
            ...prev,
            usedDateStart: event ? new Date(startDate) : null,
            usedDateEnd: event ? new Date(endDate) : null,
            page: 1,
        }));
    };

    const handleSelectChange = (field, data) => {
        setFilterUsedValue({
            value: data.value,
            label: data.label,
        });
        setFilterInput((prev) => ({
            ...prev,
            isUsed: data.value,
            page: 1,
        }));
    };

    const handleFilter = (e) => {
        const { value, name } = e.target;
        if (name === "pageSize") {
            setFilterInput((prev) => ({
                ...prev,
                pageSize: value,
            }));
        }
        if (name === "search") {
            if (e.key === "Enter" || e.keyCode === 13) {
                setFilterInput((prev) => ({
                    ...prev,
                    search: value,
                }));
            }
        }
    };

    const handleEnter =
        (type = "enter") =>
            (event) => {
                const { name, value } = event.target;
                if (event.keyCode === 13 || type === "blur") {
                    setFilterInput((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }
            };

    const closeModalSelect = () => {
        setModalSelectGadai(false)
        setSelected({})
    }

    const handleCheck = (e) => {
        setSelected(e)
    }

    const onOpenSettingVoucher = () => {
        setIsEditOrCreate('create')
        setModalSelectGadai(false)
        setModalSettingVoucher(true)
    }

    const closeModalSettingVoucher = () => {
        setDataVoucher({ name: '', amount: '' })
        setSelected({})
        setModalSettingVoucher(false)
        if (isEditOrCreate === 'create') {
            setModalSelectGadai(true)
        }
    }

    return (
        <div>
            <div className="p-3">
                <Title text="Voucher" />
                <Breadcrumb current="Voucher" />
                <div className="d-flex pt-3 px-0 mt-3">
                    <div className="d-flex col-8 px-0">
                        <TextInput
                            id="pageSize"
                            label="Tampilkan"
                            handleEnter={handleEnter}
                            handleChange={handleFilter}
                            width={68}
                            value={filterInput.pageSize}
                        />
                        <div className="col-6">
                            <TextInput
                                label="Voucher / No. SBG / Nama Nasabah"
                                id="search"
                                handleEnter={handleEnter}
                                handleChange={handleFilter}
                                width={"100%"}
                            />
                        </div>
                        <CustomDatePicker
                            id={"usedDate"}
                            label={"Tanggal Digunakan"}
                            isRangePicker
                            width={300}
                            onInputChange={handleDateChange}
                            value={transactionDateValue}
                        />
                        <div className='ml-3' />
                        <MultipleSelect
                            id={"isUsed"}
                            label={"Filter"}
                            width={300}
                            onSelectChange={handleSelectChange}
                            options={filterIsUsed}
                            value={filterUsedValue}
                        />
                    </div>

                    <div
                        className="ml-auto align-self-end mb-3"
                        onClick={() => {
                            setId();
                            setModalSelectGadai(true);
                        }}
                    >
                        <Button
                            style={{
                                alignSelf: "flex-end",
                                height: 36,
                                background: "#2C465C",
                                color: "#FFF",
                                width: 180,
                                borderRadius: 6,
                            }}
                        >
                            + Tambah Voucher
                        </Button>
                    </div>
                </div>
                <div className="mt-3">
                    <CustomTable
                        columns={renderColumns(handleEdit, handleDelete)}
                        data={records}
                        loading={loading}
                        handleTableChange={handleTableChange}
                        pagination={tablePagination}
                    />
                </div>
            </div>
            <ModalSelectGadaiBySbg
                visible={modalSelectGadai}
                onClose={closeModalSelect}
                handleCheck={handleCheck}
                selected={selected}
                onSubmit={onOpenSettingVoucher}
            />
            <ModalVoucherSetting
                selected={selected}
                visible={modalSettingVoucher}
                onClose={closeModalSettingVoucher}
                setDataVoucher={setDataVoucher}
                dataVoucher={dataVoucher}
                onSubmit={onCreateVoucher}
                errors={errors}
            />
        </div>
    )
}
